import React from 'react';

function Checkbox(props) {
  return <input {...props} type="checkbox" name="select-all" />;
}

export default Checkbox;
